// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-tooltip .ivu-tooltip-inner-with-width{white-space:normal}.calendar-tooltip .ivu-tooltip-inner-with-width .leave-time{line-height:20px}.calendar-leave-drawer .ivu-drawer-content{display:flex;flex-direction:column}.calendar-leave-drawer .ivu-drawer-header{flex-shrink:0}.calendar-leave-drawer .ivu-drawer-body{flex:1;display:flex;flex-direction:column;padding:16px 0 0 0;position:static}", ""]);
// Exports
module.exports = exports;
